<template>
  <oil-form v-if="loading"
            :title="title"
            :items="userModel"
            :createForm="!id"
            :keys="keys"
            :success-message='message'
            :formCallback="formCallback"
  >
    <template v-slot:Password="{input,rules}">
      <v-text-field
          label="Пароль"
          counter="32"
          :disabled="!input.isEdit"
          v-model="userModel.Password"
          :type="shower.passwordType"
          :append-icon="showPassword"
          @click:append="showPasswordClick"
          :rules="[...rules,min.bind(null,6)]"
          outlined
          dense
      />
    </template>

    <template v-slot:ConfirmPassword="{input}">
      <v-text-field
          counter="32"
          label="Подтвердить пароль"
          :disabled="!input.isEdit"
          v-model="shower.tmpPassword"
          @click:append="showConfirmPasswordClick"
          :rules="[confirmPassword]"
          :type="shower.passwordConfirmType"
          :append-icon="showConfirmPassword"
          outlined
          required
          dense
      />
    </template>

  </oil-form>
</template>

<script>
import keys from './setting/user.json'
import {userService} from "@/services/userService";

export default {
  props: {
    id: String
  },
  data: () => ({
    loading: false,
    title: 'Создать пользователя системы',
    keys: keys,
    email: value => {
      const pattern = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
      return pattern.test(value) || 'Invalid e-mail.'
    },
    min: (min, value) => {
      if (typeof value === 'number') {
        value = value.toString()
      }
      return value.length >= min || `Минимальная длина пароля ${min} букв`
    },
    userModel: {},
    shower: {
      tmpPassword: '',
      password: false,
      passwordType: 'password',
      passwordConfirmType: 'password',
      confirmPassword: false
    }
  }),
  components: {
    OilForm: () => import('@/components/helper/oil.form')
  },
  async created() {
    this.userModel = {
      Username: "",
      Password: "",
      Email: "",
      FullName: "",
      Role: "",
      RoleNames: ''
    }
    if (this.id) {
      const user = await userService.getById(this.id)
      this.userModel = user.data
      this.userModel.Password = ""
      this.title = 'Обновить пользователя системы'
    }
    this.loading = true
  },
  computed: {
    showPassword() {
      return this.shower.password ? 'mdi-eye-check' : 'mdi-eye-off'
    },
    showConfirmPassword() {
      return this.shower.confirmPassword ? 'mdi-eye-check' : 'mdi-eye-off'
    },
    storeType() {
      return this.id ? userService.update : userService.create
    },
    message(){
      return this.id ? 'поздравлаем пользователь удачно изменен' : 'поздравлаем пользователь удачно создан'
    }
  },
  methods: {
    async formCallback(data, input) {
      input.isEdit = false
      const user = await this.storeType(data)

      if (!user.data) {
        input.isEdit = true
        return
      }

      const tmpUser = user.data
      this.userModel.Id = tmpUser.Id
      this.userModel = tmpUser
      this.userModel.Password = ''
      this.shower.tmpPassword = ''

      if (!this.id) {
        await this.$router.replace({
          path: `/user/${this.userModel.Id}`,
        })
      }
    },
    confirmPassword(password) {
      return this.userModel.Password === password || 'Пароли не совпадают'
    },
    showPasswordClick() {
      this.shower.password = !this.shower.password
      this.shower.passwordType = this.shower.password ? 'text' : 'password'
    },
    showConfirmPasswordClick() {
      this.shower.confirmPassword = !this.shower.confirmPassword
      this.shower.passwordConfirmType = this.shower.confirmPassword ? 'text' : 'password'
    },
  }
}
</script>
